import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * The charter's type scale (`text-crow-label`, `text-crow-compact`…, from @crow/theme): font
 * sizes, so a later size replaces it and a colour (`text-crow-text-2`) never does.
 */
export const TYPE_SCALE = ['label', 'compact', 'body', 'title', 'section'] as const;

const twMerge = extendTailwindMerge({
  extend: { theme: { text: TYPE_SCALE.map((step) => `crow-${step}`) } },
});

/** Joins class names; a later Tailwind class overrides an earlier one of the same kind. */
export function cn(...values: ClassValue[]): string {
  return twMerge(clsx(values));
}

/**
 * Shared focus style: the keyboard ring in the service's accent, never on mouse clicks.
 * In Tailwind 4, `outline-hidden` (like `outline-none`) sets the outline style to none and
 * `outline-2` keeps that style, so the ring needs `outline-solid` to show at all.
 */
export const focusRing =
  'outline-hidden focus-visible:outline-2 focus-visible:outline-solid focus-visible:outline-offset-2 focus-visible:outline-crow-focus-ring';
